import { TreatmentFileKind, TreatmentFileTypeEnum } from './treatment-file.model';

export interface AiCadFile {
    readonly id: number;
    readonly fileGuid: string;
    readonly name: string;
    readonly friendlyName: string;
    readonly fileExtension: string;
    readonly fileType: TreatmentFileTypeEnum;
    readonly fileKind: TreatmentFileKind;
    readonly teeth?: string | null;
    readonly size: number;
    readonly createdDate?: string | Date | null;
    readonly downloadUrl: string;
}
